import { BrowserModule } from '@angular/platform-browser'
import { NgModule, ErrorHandler, Injectable } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { HttpModule } from '@angular/http'
import { RouterModule } from '@angular/router'

import { NgSelectModule } from '@ng-select/ng-select'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import {
  HashLocationStrategy,
  LocationStrategy,
  DatePipe,
} from '@angular/common'

import { MatInputModule } from '@angular/material/input'
import {
  MatNativeDateModule,
  MatExpansionModule,
  MatTableModule,
} from '@angular/material'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatButtonModule, MatToolbarModule } from '@angular/material'
import { MatStepperModule } from '@angular/material/stepper'
import { MatIconModule } from '@angular/material/icon'

import { AppRoutingModule } from './app.routing'

import { SidebarComponent } from './shared/sidebar/sidebar.component'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatChipsModule } from '@angular/material/chips'
import { MatCardModule } from '@angular/material/card'
import { MatFormFieldModule } from '@angular/material/form-field'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
//import { LbdModule } from './lbd/lbd.module';
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { AppComponent } from './app.component'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'

import { TokenInterceptor, JwtInterceptor } from './_helpers'

import {
  AlertComponent,
  HasPermissionDirective,
  NewConsumerDirective,
  NewConsumerLkoDirective,
  SearchPipe,
  CouponHistoryDirective,
  GridContextMenuComponent,
  DropDownListFilterComponent,
} from './_directives'
import { AuthGuard } from './_guards'

import { AlertService, AuthService } from './_services'
import { LoginComponent } from './login/login.component'
import { Broadcaster } from 'environments/broadcaster'

import { DashboardComponent } from './dashboard/dashboard.component'

import { AlarmComponent } from './alarm/alarm.component'

import { AlarmFuelComponent } from './alarm/alarmFuel/alarmFuel.component'

import { AlarmSummaryComponent } from './alarm/alarmSummary/alarmSummary.component'

import { FuelAlertComponent } from './alarm/fuelAlert/fuelAlert.component'

import { UccComponent } from './dashboard/ucc/ucc.component'

import { ProjectComponent } from './dashboard/project/project.component'

import { MaptrackerComponent } from './maptracker/maptracker.component'
import { VehiclesComponent } from './maptracker/vehicles/vehicles.component'
import { mcgVehiclesComponent } from './maptracker/vehicles/mcgVehicles.component'
import { SecondaryOpsComponent } from './maptracker/vehicles/secondaryOps.component'

import { maptrackerDashboardComponent } from './maptracker/maptracker-dashboard/maptrackerDashboard.component'

import { AreaComponent } from './maptracker/area/area.component'
import { BeatComponent } from './maptracker/area/beat.component'

//import {KccComponent} from 'app/maptracker/kcc/kcc.component';

import { StopComponent } from './maptracker/stop/stop.component'

import { NavbarComponent } from './shared/navbar/navbar.component'

import { ComplainDashBoardComponent } from 'app/dashboard/complain/complain.component'
import { TargetDashBoardComponent } from 'app/dashboard/target/targetDashboard.component'
import { TonnageDashBoardComponent } from 'app/dashboard/tonnage/tonnageDashboard.component'
import { AdminComponent } from './admin/admin.component'
import { EmployeeComponent } from './admin/employee/empMngt/employee.component'
import { DriverComponent } from './admin/employee/empMngt/driver.component'
import { EmpComponent } from './admin/employee/emp.component'
import { VehicleComponent } from './admin/vehicles/vehicleMngt/vehicles.component'
import { EntityComponent } from './admin/entity/entityMngt/entity.component'
import { EntComponent } from './admin/entity/ent.component'
//HRMS COMPONENT
import { HrmsComponent } from './admin/hrms/hrms.component'
import { HrmsEmployeeComponent } from './admin/hrms/hrmsMnt/hrmsEmployee.component'
import { TargetComponent } from './admin/target/target.component'
import { TargetMasterComponent } from './admin/target/targetMaster/targetMaster.component'
import { OrderBy } from './maptracker/vehicles/vehicles.component'
//TS MAPPING
import { TsComponent } from './maintenance/TS/transferStation.component'
import { TsMasterComponent } from './maintenance/TS/tsMaster/tsMaster.component'

/*
  Khatta Component
*/

import { AddNewVehiclesComponent } from './admin/vehicles/vehicleMngt/vehicles.AddNewVehicles'
import { VehComponent } from './admin/vehicles/veh.component'

import { ReportsComponent } from './reports/reports.component'
import { HomeComponent } from './home/home.component'
import { NgDatepickerModule } from 'ng2-datepicker'

//Added by Ram on 15_03_2018 For Loading message popup
import { ImageUploadModule } from 'angular2-image-upload' //Added by Ram on 19_03_2018 For uploading image in add user model popup page
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
//this component for add new vehicles only.
//For Report cr by ram on )8_03_2018
import { UccReportsComponent } from './reports/uccReport/uccReport.Component'
import { BulkCollectionReportComponent } from './reports/uccReport/bulkCollectionReport.Component'
import { CollectionAnalysisReport } from './reports/uccReport/collectionAnalysisReport.Component'
import { CollectionSummaryComponent } from './reports/uccReport/collectionSummaryReport.Component'

// #atul Doortodoor comp
import { DoorToDoorComponent } from './reports/doorToDoorMixedwaste/doorToDoor.component'

//CRM
import { CRMComponent } from './crm/crm.component'

//KCC
import { ConsumerComponent } from './crm/kcc/consumer/consumer.component'
import { KccComponent } from './crm/kcc/kcc.component'
import { ConsumerListComponent } from './crm/kcc/consumer/consumerList/consumerList.component'
import { InvoiceComponent } from './crm/kcc/invoice/invoice.component'
import { InvoiceListComponent } from './crm/kcc/invoice/invoiceList/invoiceList.component'
import { CreateInvoiceComponent } from './crm/kcc/invoice/createInvoice/createInvoice.component'

//KCC  LKO
import { ConsumerLkoComponent } from './crm/kccLko/consumerLko/consumerLko.component'
import { KccLkoComponent } from './crm/kccLko/kccLko.component'
import { ConsumerListLkoComponent } from './crm/kccLko/consumerLko/consumerListLko/consumerListLko.component'
import { InvoiceLkoComponent } from './crm/kccLko/invoiceLko/invoiceLko.component'
import { InvoiceListLkoComponent } from './crm/kccLko/invoiceLko/invoiceListLko/invoiceListLko.component'
import { CreateInvoiceLkoComponent } from './crm/kccLko/invoiceLko/createInvoiceLko/createInvoiceLko.component'

import { PaymentLkoComponent } from './crm/kccLko/paymentLko/paymentLko.component'
import { PaymentListLkoComponent } from './crm/kccLko/paymentLko/paymentListLko/paymentListLko.component'

//commentstat

//KCC
import { ComplainComponent } from './crm/complain/complain.component'
import { ComplainListComponent } from './crm/complain/complainList/complainList.component'

import { PaymentComponent } from './crm/kcc/payment/payment.component'
import { PaymentListComponent } from './crm/kcc/payment/paymentList/paymentList.component'

import { SuperAdminComponent } from './superAdmin/superAdmin.component'

import { ServerMonitoring } from './superAdmin/users/serverMonitoring.component'
import { UccUserComponent } from './superAdmin/users/uccUser.component'
import { UsersComponent } from './superAdmin/users/users.component'

import { AccessDetailsComponent } from './superAdmin/users/accessDetails.component'

// AccessDetailsComponent

//This Library Added for Multiselect

//This is for Table Paginations.
//import {MatPaginatorModule} from '@angular/material/paginator';
//for data Table
//import { DataTablesModule } from 'angular-datatables';

import { PagerService } from './_services/pager.service'

import { LightboxModule } from 'angular2-lightbox'

///Date and Time Picker
import { AngularDateTimePickerModule } from 'angular2-datetimepicker'

//Loader service
import { LoaderService } from './_services/loader.service'

//import { DaterangepickerModule } from 'angular-2-daterangepicker';
//import { PopoverModule } from 'ng2-popover';
import { MyDateRangePickerModule } from 'mydaterangepicker'
//import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import {
  GridModule,
  ExcelModule,
  PDFModule,
} from '@progress/kendo-angular-grid'

import { PopupModule } from '@progress/kendo-angular-popup'
import { DropDownListModule } from '@progress/kendo-angular-dropdowns'

//import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { MenuModule } from '@progress/kendo-angular-menu'
import { DropDownsModule } from '@progress/kendo-angular-dropdowns'
//UCC

//Ucc collection Received Section cr by ram on 10_07_2018

import { ChartsModule } from '@progress/kendo-angular-charts'

//KCC report--KccSummaryReportComponent
import { KccReportsComponent } from './reports/kccReport/kccReport.component'
import { KccSummaryReportComponent } from './reports/kccReport/kccSummaryReport.component'
import { KccCustomerReportComponent } from './reports/kccReport/kccCustomerReport.component'
import { KccDetailReportComponent } from './reports/kccReport/kccDetailReport.component'
import { EntitySummaryReportComponent } from './reports/entityReport/entitySummaryReport.component'
import { EntitysComponent } from './reports/entityReport/entity.component'

import { KccConsolidatedReportComponent } from './reports/kccReport/kccConsolidatedReport.component'

import { NgxSelectModule } from 'ngx-select-ex'

import { NgxPaginationModule } from 'ngx-pagination'

//import {MaintMntComponent} from './maintenance/maintMaster/maintMnt.component';
//import {VehMaintenanceMasterComponent} from './maintenance/maintMaster/master/maintenanceMaster.component';

import { LogbookComponent } from './maintenance/vehicleMaintenance/vehicleMnt/logbook.component'
import { SubstituteComponent } from './maintenance/vehicleMaintenance/vehicleMnt/substitute.component'
import { VehMaintenanceApprovalComponent } from './maintenance/vehicleMaintenance/vehicleMnt/VehicleMaintenanceApproval'
import { jobCardApprovalComponent } from './maintenance/vehicleMaintenance/vehicleMnt/jobCardApproval.component'

import { TSLogbookComponent } from './maintenance/TS/tsMaster/tsLogbook.component'

//Mobility Import cr by Ram on 24-08-2018
import { MobilityReportComponent } from './reports/mobilityReport/mobility.component'
import { ServiceReportComponent } from './reports/mobilityReport/serviceReport.component'
import { SurveyReportComponent } from './reports/mobilityReport/surveyReport.component'
import { MobilityComponent } from './mobility/mobility.component'
import { MobilityUserComponent } from './mobility/user/mobilityUser.component'
import { KhattaServiceReportComponent } from './mobility/khattaService/khattaServiceReport.component'
import { MappingReportComponent } from './reports/mobilityReport/mappingReport.component'

// Reports
import { VehiclePlantComponent } from './reports/plant/plant.component'

import { VtsReportsComponent } from './reports/vtsReport/vtsReport.component'
import { DriverVehicleComponent } from './reports/vtsReport/driverVehicle.component'
import { DistanceComponent } from './reports/vtsReport/distanceReport.component'
import { VtsDailyReportComponent } from './reports/vtsReport/vtsDailyReport.component'
import { DistanceFuelComponent } from './reports/vtsReport/distanceFuel.component'

import { VtsStatusDailyCountComponent } from './reports/vtsReport/vtsStatusDailyCount.component'

import { routeCoverReportComponent } from './reports/vtsReport/routeCoverReport.component'

// secondaryReportComponent

import { secondaryReportComponent } from './reports/vtsReport/secondaryReport.component'

import { CrmReportComponent } from './reports/crmReport/crmReport.component'
import { ComplainReportComponent } from './reports/crmReport/complainReport.component'
import { VehicleReport } from './reports/vehicleReport/vehicleReport.component'
import { PrimaryVehicleReport } from './reports/vehicleReport/primaryVehicleReport.component'

import { PrimaryAssignmentComponent } from './reports/vehicleReport/primaryVehicleAssignment'

import { PrimaryliveTrackingReport } from './reports/vehicleReport/primaryLiveTracking.component'

import { PrimaryVehicleTripReport } from './reports/vehicleReport/primaryVehicleTrip.component'

import { PrimaryUnservedAreaReport } from './reports/vehicleReport/primaryUnservedArea.component'

import { SecondaryReport } from './reports/secondary/secondaryReport.component'
import { SecondaryliveTrackingReport } from './reports/secondary/secondaryLiveTracking.component'
import { SecondaryAssignmentComponent } from './reports/secondary/secondaryAssignment.componant'
import { FuelReportComponent } from './reports/fuel/fuel.component'
import { FuelPurchaseReportComponent } from './reports/fuel/fuelPurchase.component'
import { FuelLooseReportComponent } from './reports/fuel/fuelLoose.component'
import { FuelDistributionReportComponent } from './reports/fuel/fuelDistribution.component'
import { FuelMasterReportComponent } from './reports/fuel/fuelMaster.component'

import { CollectionReportComponent } from './reports/uccReport/couponCollection.component'
import { AttendComponent } from './reports/attendance/attend.component'
import { AttendanceReportComponent } from './reports/attendance/attendance.component'

import { AttendanceDeatilComponent } from './reports/attendance/attendanceDetail.component'
import { ProjectSummaryComponent } from './dashboard/project/projectSummary.component'
//New UCC
import { CrmUccComponent } from './crm/ucc/ucc.component'
import { GrnComponent } from './crm/ucc/grn/grnList.component'
import { CouponAssignComponent } from './crm/ucc/couponAssignment/couponAssignment.component'
import { CouponCollectionComponent } from './crm/ucc/couponCollection/couponCollection.component'
import { CouponReturnComponent } from './crm/ucc/couponReturn/couponReturn.component'
import { CouponMissingComponent } from './crm/ucc/missingCoupon/missingCoupon.component'
import { InventorySummaryComponent } from './crm/ucc/inventory/inventorySummary.component'
import { InventoryDetailComponent } from './crm/ucc/inventory/inventoryDetail.component'
import { CollectionReceivedComponent } from './crm/ucc/couponReceived/collectionReceived.component'
import { BulkCouponCollectionComponent } from './crm/ucc/bulkCouponCollection/bulkCouponCollection.component'
import { WmDispatchComponent } from './reports/mobilityReport/wmDispatch.component'
import { MileageReportComponent } from './reports/fuel/fuelMileage.component'
import { VehMaintStatusComponent } from './maintenance/vehicleMaintenance/vehicleMnt/vehMaintenanceStatus.component'

import { UccCollectionReportComponent } from './reports/uccReport/uccCollectionReport.Component'

import { UccDefaulterComponent } from './reports/uccReport/uccDefaulter.component'

import { VehicleStopDetailComponent } from './reports/vtsReport/vehicleStop.component'

import { from } from 'rxjs/observable/from'

// added by suraj
import { PlantComponent } from './reports/plant/plantReport.component'
import { GooglePlaceModule } from 'ngx-google-places-autocomplete'
import { AngularFireModule } from 'angularfire2'
import { AngularFirestore } from 'angularfire2/firestore'
import { AngularFireDatabaseModule } from 'angularfire2/database'
import { AngularFireAuthModule } from 'angularfire2/auth'
import { VehMaintenanceService } from './maintenance/vehicleMaintenance/vehicleMnt/vehMaintenance.service'
import { MaintenanceComponent } from './maintenance/maintenance.component'
import { VehicleMaintenanceComponent } from './maintenance/vehicleMaintenance/vehicleMnt/vehicleMaintenance.component'
import { VehicleMaintMntComponent } from './maintenance/vehicleMaintenance/vehicleMnt.component'
import { PartComponent } from './maintenance/part/part.component'
import { PartMasterComponent } from './maintenance/part/partMaster/partMaster.component'
import { PartDashboardComponent } from './maintenance/part/PartDashboard/PartDashboard.component'

import { VendorMasterComponent } from './maintenance/part/vendorMaster/vendorMaster.component'

import { UccTransactionComponent } from './reports/uccReport/uccTransaction.component'

import { UccMappingComponent } from './reports/uccReport/uccMapping.Component'

import { UccTransactionReprintComponent } from './reports/uccReport/uccReprintReport.component'
import { UccDashboardComponent } from './reports/uccReport/uccDashboard.component'
import { UccUsersComponent } from './reports/uccReport/uccUsers.Component'
import { RdfComponent } from './reports/plant/rdf.component'
import { TransferStationComponent } from './reports/plant/trasnferStation.component'

import { weighbridgeDeatsils } from './reports/plant/weighbridgeDeatsils.component'

import { manualFileUpload } from './reports/plant/manualFileUpload.component'

import { transferStationDataView } from './reports/plant/transferStationDataView.component'

import { transferStationDetails } from './reports/plant/transferStationDetails.component'

// weighbridgeDeatsils

import { AlarmsComponent } from './maptracker/vehicles/alarms.component'
import { KccDashboardComponent } from './reports/kccReport/kcc-dashboard.component'
import { CostControlComponent } from './reports/cost-control/cost-control.component'
import { CombbinedReportComponent } from './reports/cost-control/combbined-report/combbined-report.component'
import { UccPotentialComponent } from './maptracker/stop/ucc-potential.component'
import { environment } from 'environments/environment'
import { HrComponent } from './reports/hr/hr.component'
import { EcokraComponent } from './reports/hr/ecokra.component'
import { PctsComponent } from './reports/plant/pcts.component'
import { TsMaintenanceComponent } from './maintenance/TS/tsMaster/ts-maintenance.component'
import { UccUsersService } from './reports/uccReport/uccUsers.service'
import { BankmstComponent } from './crm/kcc/bankmst/bankmst.component'
import { KccReqComponent } from './crm/kcc/kccRequests/kccRequests.component'
import {
  McgDashboardComponent,
  OrderByMCG,
} from './maptracker/mcg-dashboard/mcg-dashboard.component'
import { VehDashboardComponent } from './maptracker/veh-dashboard/veh-dashboard.component'
import { previousVtsData } from './maptracker/previous-vts-data/previous-vts-data.component'

import { IswmComponent } from './iswmMgt/iswm.component'

import { LocationMgt } from './iswmMgt/Location/locations.component'
import { deviceDetailsMgt } from './iswmMgt/custom/deviceDetails.component'

import { RoutePlanComponent } from './admin/vehicles/vehicleRoutesMngt/routeplan.component'
import { RouteAssignment } from './admin/vehicles/routesAssignments/routeAssignment.component'

import { dataRectifyComponent } from './dataRectify/dataRectify.component'
import { weighbridgeDataComponent } from './dataRectify/weighbridgeData/weighbridgeData.component'
import { plantDataComponent } from './dataRectify/weighbridgeData/plantData/plantData.component'
import { tsDataComponent } from './dataRectify/weighbridgeData/tsData/tsData.component'
import { PlantComponentTest } from './reports/plant/plantReportTest.component'
import { EInvoicingComponent } from './crm/kcc/e-invoicing/e-invoicing.component'
import { VehDeploymentComponent } from './admin/vehicles/deploymentUploader/veh-deployment.component'
import { CompleteDashboardComponent } from './reports/uccReport/completeDashboard.component'
import { KMEntriesComponent } from './reports/fleet-report/km.component'
import { FleetReportsComponent } from './reports/fleet-report/fleetReport.component'
import { InvoiceUploaderComponent } from './crm/kcc/invoice-uploader/invoice-uploader.component'
import { khattaPointsComponent } from './maptracker/stop/khatta.component'
import { FuelUserComponent } from './superAdmin/users/fuelUser.component'
import { KmEntryFormComponent } from './reports/fleet-report/kmEntryForm.component'
import { UccPermsService } from './superAdmin/users/UccPerms.service'
import { InventoryService } from './maintenance/part/partMaster/inventory.service'
import { LiveTrackingComponent } from './maptracker/live-tracking/live-tracking.component'
import { PaginationDirective } from './_directives/pagination.directive'
import { FuelTempComponent } from './reports/fuel/fuelTemp.component'
import { VtsStatusComponent } from './superAdmin/users/vtsStatus.component'

import { ItAssetComponent } from './superAdmin/users/itAsset.component'
import { ipWhitlistComponent } from './superAdmin/users/ipWhitlist.component'

import { DriverVehdetailsComponent } from './admin/vehicles/DriversAndVehicles/DriverVehdetails.component'
import { GraphicalVievComponent } from './reports/fuel/graphicalView.component'

// engine Oil
import { EngineoilComponent } from './maintenance/EngineOil/ebgineOil/engineoilfile.component'
import { EngineComponent } from './maintenance/EngineOil/engineOil.component'

// search all reports

import { allReportsComponent } from './AllReports/Reports/allReports.component'
import { allReportsMainComponent } from './AllReports/allReportsMain.component'

// maintenanceSummaryComponent Dashboard

import { maintenanceSummaryComponent } from './maintenance/maintenanceSummary/maintenanceSummary.component'
import { maintenanceSummaryDashboardComponent } from './maintenance/maintenanceSummary/maintenanceSummaryDashboard/maintenanceSummaryDashboard.component'

// MaintenanceSummaryComponent
import { MaintenanceSummaryBriefComponent } from './maintenance/maintenanceSummary/maintenanceSummaryDashboard/summary.component'
import { invoiceAndChallanComponent } from './maintenance/part/InvoiceAndChallan/invoiceAndChallan.component'
import { vehicleHistoryService } from './admin/vehicles/vehicleMngt/vehicleHistory.service'
import { AssetReportComponent } from './reports/itAsset/asset.component'
import { AssetIssueDetailsReportComponent } from './reports/itAsset/assetIssueDetails.components'
import { AssetMasterDetailsReportComponent } from './reports/itAsset/assetMasterDetails.components'

// import { AlarmsModule } from './alarms/alarms.module';
// import { JwPaginationComponent } from 'jw-angular-pagination'

// import * as Sentry from "@sentry/browser";

// Sentry.init({
//   dsn: "https://75180dc185f24d0b99d93a1793875c6c@sentry.io/1440828"
// });

// @Injectable()
// export class SentryErrorHandler implements ErrorHandler {
//   constructor() {}
//   handleError(error) {
//     const eventId = Sentry.captureException(error.originalError || error);
//     Sentry.showReportDialog({ eventId });
//   }
// }

@NgModule({
  declarations: [
    AssetReportComponent,
    AssetIssueDetailsReportComponent,
    AssetMasterDetailsReportComponent,
    AppComponent,
    HomeComponent,
    LoginComponent,
    UccComponent,
    // DummyComponent,

    ComplainComponent,
    ComplainDashBoardComponent,
    TargetDashBoardComponent,
    TonnageDashBoardComponent,
    AdminComponent,
    ProjectComponent,
    DashboardComponent,
    AlarmComponent,
    AlarmFuelComponent,
    AlarmSummaryComponent,
    FuelAlertComponent,
    //Employee
    EmployeeComponent,
    DriverComponent,
    EmpComponent,
    AreaComponent,
    BeatComponent,

    VehiclesComponent,
    mcgVehiclesComponent,
    maptrackerDashboardComponent,
    SecondaryOpsComponent,
    VehComponent,
    StopComponent,
    MaptrackerComponent,
    AlertComponent,
    SearchPipe,
    OrderBy,
    OrderByMCG,
    CRMComponent,
    ConsumerComponent,
    ConsumerListComponent,
    InvoiceComponent,
    InvoiceListComponent,

    ConsumerLkoComponent,
    ConsumerListLkoComponent,
    InvoiceLkoComponent,
    InvoiceListLkoComponent,
    CreateInvoiceLkoComponent,
    PaymentLkoComponent,
    PaymentListLkoComponent,

    PaymentComponent,
    PaymentListComponent,
    CreateInvoiceComponent,
    ComplainListComponent,
    EntityComponent,
    EntComponent, //Admin
    AddNewVehiclesComponent,
    VehicleComponent,
    ReportsComponent,
    UccReportsComponent,
    SidebarComponent,
    NavbarComponent,
    HasPermissionDirective,
    NewConsumerDirective,
    NewConsumerLkoDirective,
    CouponHistoryDirective,
    SuperAdminComponent,
    ServerMonitoring,
    UccUserComponent,
    UsersComponent,
    AccessDetailsComponent,
    KccComponent,
    KccLkoComponent,
    BulkCollectionReportComponent,
    CollectionAnalysisReport,
    CollectionSummaryComponent,
    GridContextMenuComponent,
    DropDownListFilterComponent,
    KccReportsComponent,
    KccSummaryReportComponent,
    KccCustomerReportComponent,
    KccDetailReportComponent,
    KccConsolidatedReportComponent,
    EntitySummaryReportComponent,
    EntitysComponent,
    MaintenanceComponent,
    LogbookComponent,
    SubstituteComponent,
    VehMaintenanceApprovalComponent,
    jobCardApprovalComponent,
    TSLogbookComponent,
    VehicleMaintenanceComponent,
    VehicleMaintMntComponent,
    // VehMaintenanceMasterComponent,
    // PartCategoryComponent,
    //Mobility Report
    MobilityReportComponent,
    ServiceReportComponent,
    SurveyReportComponent,
    MobilityComponent,
    MobilityUserComponent,
    KhattaServiceReportComponent,
    CrmReportComponent,
    ComplainReportComponent,
    MappingReportComponent,
    VtsReportsComponent,
    DriverVehicleComponent,
    DistanceComponent,
    VtsDailyReportComponent,
    DistanceFuelComponent,
    VtsStatusDailyCountComponent,
    routeCoverReportComponent,
    secondaryReportComponent,
    VehicleReport,
    PrimaryVehicleReport,
    PrimaryAssignmentComponent,
    PrimaryliveTrackingReport,
    PrimaryVehicleTripReport,
    PrimaryUnservedAreaReport,
    SecondaryReport,
    SecondaryliveTrackingReport,
    SecondaryAssignmentComponent,
    //Plant report
    VehiclePlantComponent,
    PlantComponent,
    RdfComponent,
    TransferStationComponent,
    weighbridgeDeatsils,
    manualFileUpload,
    transferStationDataView,
    transferStationDetails,
    FuelReportComponent,
    FuelPurchaseReportComponent,
    FuelLooseReportComponent,
    FuelDistributionReportComponent,
    FuelMasterReportComponent,
    GraphicalVievComponent,
    CollectionReportComponent,
    AttendComponent,
    AttendanceReportComponent,
    AttendanceDeatilComponent,
    ProjectSummaryComponent,
    //New UCC (24-10-2018)
    CrmUccComponent,
    GrnComponent,
    CouponAssignComponent,
    CouponCollectionComponent,
    CouponReturnComponent,
    CouponMissingComponent,
    InventorySummaryComponent,
    InventoryDetailComponent,
    CollectionReceivedComponent,
    BulkCouponCollectionComponent,
    WmDispatchComponent,
    MileageReportComponent,
    VehMaintStatusComponent,
    HrmsComponent,
    HrmsEmployeeComponent,
    TargetComponent,
    TargetMasterComponent,
    TsComponent,
    TsMasterComponent,
    PartComponent,
    PartMasterComponent,
    PartDashboardComponent,
    VendorMasterComponent,
    UccCollectionReportComponent,
    UccTransactionComponent,
    UccMappingComponent,
    UccTransactionReprintComponent,
    UccDefaulterComponent,
    UccDashboardComponent,
    UccUsersComponent,
    VehicleStopDetailComponent,
    AlarmsComponent,
    KccDashboardComponent,
    CostControlComponent,
    CombbinedReportComponent,
    UccPotentialComponent,
    HrComponent,
    EcokraComponent,
    PctsComponent,
    TsMaintenanceComponent,
    BankmstComponent,
    KccReqComponent,
    McgDashboardComponent,
    VehDashboardComponent,
    previousVtsData,

    IswmComponent,

    LocationMgt,
    deviceDetailsMgt,

    RoutePlanComponent,
    RouteAssignment,

    DriverVehdetailsComponent, // 28/01/2022

    dataRectifyComponent,
    weighbridgeDataComponent,
    plantDataComponent,
    tsDataComponent,
    PlantComponentTest,
    EInvoicingComponent,
    VehDeploymentComponent,
    CompleteDashboardComponent,
    FleetReportsComponent,
    KMEntriesComponent,
    KmEntryFormComponent,
    InvoiceUploaderComponent,
    khattaPointsComponent,
    FuelUserComponent,
    LiveTrackingComponent,
    // JwPaginationComponent,
    PaginationDirective,
    FuelTempComponent,
    VtsStatusComponent,
    ItAssetComponent,
    ipWhitlistComponent,

    // doortodoor
    DoorToDoorComponent,
    EngineoilComponent,
    EngineComponent,

    allReportsComponent,
    allReportsMainComponent,

    // dashboard maintenance
    maintenanceSummaryComponent,
    maintenanceSummaryDashboardComponent,
    MaintenanceSummaryBriefComponent,
    invoiceAndChallanComponent,
  ],

  imports: [
    MatInputModule,
    LightboxModule,
    DropDownListModule,
    DropDownsModule,
    GooglePlaceModule,
    NgbModule.forRoot(),
    // NgPipesModule,
    // PDFExportModule,
    PopupModule,
    MatTableModule,
    ExcelModule,
    PDFModule,
    MenuModule,
    //ToolBarModule,
    GridModule,
    //DateInputsModule,
    MatDatepickerModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    //LbdModule,
    NgSelectModule,
    NgDatepickerModule,
    MatFormFieldModule,
    BrowserAnimationsModule,
    MatChipsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatButtonModule,
    MatToolbarModule,
    MatExpansionModule,
    MatStepperModule,
    MatIconModule,

    // imports firebase/firestore, only needed for database features
    AngularFireModule.initializeApp(environment.firebaseMobilityConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    // imports firebase/auth, only needed for auth features,

    MatNativeDateModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    ImageUploadModule, //for Image upload;
    MatRadioModule, //For Radio button in employee Page
    MatSelectModule,
    MatCheckboxModule,
    AngularDateTimePickerModule,
    MyDateRangePickerModule,
    ChartsModule,
    NgxSelectModule,
    NgxPaginationModule,
    // AlarmsModule
  ],
  entryComponents: [],
  providers: [
    AlertService,
    AuthService,
    AuthGuard,
    Broadcaster,
    PagerService,
    DatePipe,
    LoaderService,
    VehMaintenanceService,
    AngularFirestore,
    UccUsersService,
    UccPermsService,
    vehicleHistoryService,
    InventoryService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    //{ provide: ErrorHandler, useClass: SentryErrorHandler }
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts